import type {NearV1Quote,NearV1PrepareRequest} from '../../../../packages/sdk/src/near';
import {canonicalRaw} from './near-lifecycle';

export function slippagePercentToBps(value:string):number {
  const text=value.trim();
  if(!/^(0|[1-9][0-9]?)(\.[0-9]{1,2})?$/.test(text))throw Error('Enter slippage from 0% to 99.99%, with at most two decimal places.');
  const [whole,fraction='']=text.split('.');
  return Number(whole)*100+Number(fraction.padEnd(2,'0'));
}
export function balancePortion(availableRaw:string,bps:number):string {
  if(!Number.isInteger(bps)||bps<0||bps>10000)throw Error('Invalid balance percentage');
  return (canonicalRaw(availableRaw)*BigInt(bps)/10000n).toString();
}
export function curveReviewInput(quote:NearV1Quote,minimumRaw:string,now=Date.now()):
  Omit<NearV1PrepareRequest,'accountId'|'network'> {
  if(!quote.quoteId||!quote.trader)throw Error('Refresh quote identity and slippage review.');
  if(quote.expiresAt<=now)throw Error('Quote expired. Refresh and review again.');
  const minimum=canonicalRaw(minimumRaw);
  if(minimum<canonicalRaw(quote.trader.minimumOutput.raw))throw Error('Minimum is below the reviewed slippage floor. Refresh the quote to change slippage.');
  if(minimum>canonicalRaw(quote.expectedOutput.raw))throw Error('Minimum exceeds expected output.');
  return {action:quote.action,launchId:quote.launchId,amountRaw:quote.input.raw,
    minimumOutputRaw:minimumRaw,quoteId:quote.quoteId,slippageBps:quote.trader.slippageBps,
    routeId:quote.routeId,expiresAt:quote.expiresAt};
}
